const statuses = {
    waiting: 'waiting',
    ready: 'ready',
    entered: 'entered',
    timeout: 'timeout',
};

const OnlineInterviewUserStatuses = {
    isWaiting: status => status === statuses.waiting,
    isReady: status => status === statuses.ready,
    isEntered: status => status === statuses.entered,
    isTimeout: status => status === statuses.timeout,
};

export default OnlineInterviewUserStatuses;
